import { render, staticRenderFns } from "./AdminButtons.vue?vue&type=template&id=265c2a72&scoped=true&"
import script from "./AdminButtons.vue?vue&type=script&lang=ts&"
export * from "./AdminButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c2a72",
  null
  
)

export default component.exports